import React from 'react'
import { useTranslation } from 'react-i18next'

import { Chip } from '@/components/Chip/Chip'
import { Card } from '@/components/ui/card'
import type { ISkills } from '@/store/api/Person/Person.types'

import { EmptyStateCard, EmptyStateCardIcon } from './EmptyStateCard'

interface SkillsWidgetTypes {
  skills: ISkills[]
}

export const SkillsWidget = ({ skills }: SkillsWidgetTypes) => {
  const { t } = useTranslation()
  return (
    <Card className="flex flex-col bg-baseColor p-4 gap-4">
      <p className="flex text-neutralColor text-xl font-medium">
        {t('report.generalInfo.skills')}
      </p>
      {skills.length !== 0 ? (
        <div className="flex gap-3 flex-wrap items-start">
          {skills.slice(0, 16).map((skill, index) => (
            <Chip text={skill.name} key={index} variant="blue" size="medium" />
          ))}
        </div>
      ) : (
        <EmptyStateCard
          title={t('report.generalInfo.skillsEmpty')}
          icon={EmptyStateCardIcon.PERSON}
        />
      )}
    </Card>
  )
}
